"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const InputGroup_1 = tslib_1.__importDefault(require("reactstrap/lib/InputGroup"));
const EyeToggle_1 = require("./EyeToggle");
exports.PasswordInput = ({ onFocusChange, value, onCapsLockChange, onChange, }) => {
    const [revealPassword, toggleRevealPassword] = react_use_1.useToggle(false);
    const [hasFocused, toggleHasFocused] = react_use_1.useToggle(false);
    return (react_1.default.createElement(InputGroup_1.default, null,
        react_1.default.createElement(reactstrap_1.Input, { placeholder: "Password", type: revealPassword ? 'text' : 'password', name: "password", value: value, className: "border-right-0", autoComplete: "current-password", onChange: e => {
                onChange(e.target.value);
            }, onFocus: () => {
                onFocusChange(true);
                toggleHasFocused(true);
            }, onBlur: () => {
                onFocusChange(false);
            }, onKeyUp: e => {
                onCapsLockChange(e.getModifierState('CapsLock'));
            } }),
        react_1.default.createElement(EyeToggle_1.EyeToggle, { active: revealPassword, show: hasFocused, onChange: newReveal => {
                toggleRevealPassword(newReveal);
            } })));
};
//# sourceMappingURL=PasswordInput.js.map